module.exports = __webpack_public_path__ + "img/wolf_2.c72b2277.jpg";